import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../../utils/api";
import { showErrorToast, showSuccessToast } from "../../utils/toast";

const CancelPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [canceled, setCanceled] = useState(false);

  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      showErrorToast("Missing session ID.");
      setLoading(false);
      return;
    }

    const cancelPayment = async () => {
      try {
        const response = await api("v1/selfsignup/payment-cancel", "POST", { sessionId });

        if (response.data.success) {
          showSuccessToast("Payment was canceled.");
          setCanceled(true);
        } else {
          showErrorToast(response.data.message || "Failed to update cancellation.");
        }
      } catch (error) {
        console.error("Error processing cancellation:", error);
        showErrorToast("An error occurred while canceling the payment.");
      }
      setLoading(false);
    };

    cancelPayment();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
      <div className="bg-white p-8 shadow-md rounded-lg text-center">
        <h2 className="text-xl font-bold mb-4">{loading ? "Processing..." : "Payment Canceled"}</h2>
        <p className="text-gray-600">
          {loading ? "Please wait while we update your status..." :
            "Your payment was not completed. If this was a mistake, you can try again."
          }
        </p>
        {!loading && (
          <button className="mt-4 bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold" onClick={() => navigate("/")}>
            Return to Home
          </button>
        )}
      </div>
    </div>
  );
};

export default CancelPage;
